import React from 'react'
import {bindActionCreators} from 'redux'
import {routerActions} from 'react-router-redux'
import { connect } from 'react-redux'
import {Button, Row,Col} from 'reactstrap';
import {resetQuiz} from '../actions'
import {quiz_path,default_qnum} from '../constants'
class StartPage extends React.Component {
	constructor(props) {
		super(props)
		this.startClick = this.startClick.bind(this)	//binding
	}
	startClick(){
		this.props.resetQuiz(); // isquizready: false
		this.props.push(quiz_path+default_qnum)// Move to first question
	}
	render(){
		return (
			<div>
				<Row>
					<Col className="text-center"><h3>MA10 CEAFE TEST</h3></Col>
				</Row>	
				<Row>
					<Col className="text-center"> 
						<h3>
							<Button color="primary" size="lg" onClick={this.startClick}>Start!</Button>
						</h3>
					</Col>
				</Row>
			</div>
		);
	}			
}
// redux state to component props
const mapStateToProps=(state)=>{
  const {isFetching,issuccessful}=state
  return{
    isFetching,
    issuccessful,
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
  		push: routerActions.push,
		resetQuiz  	
  }, dispatch)
}
//https://github.com/rackt/react-redux/blob/master/docs/api.md#connectmapstatetoprops-mapdispatchtoprops-mergeprops-options
// "connect" returns a new component class connected to a redux store.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StartPage)


// WEBPACK FOOTER //
// ./src/containers/StartPage.js